import { Icon } from '@aibees/shared/components';
import { Box } from '@mui/material';
import { memo } from 'react';
import * as SX from './sx';
import type { CustomAccordionExpandIconProps as Props } from './types';

export const CustomAccordionExpandIcon = memo(
  ({ open, size, disabled }: Props) => {
    return (
      <Box sx={SX.accordionAction(size)}>
        <Box sx={SX.iconContainer}>
          <Icon
            size={size ?? 18}
            color={!disabled && open ? 'primary' : 'grey.500'}
            name="chevron-down"
            sxx={SX.iconHover(disabled)}
          />
        </Box>
      </Box>
    );
  }
);

CustomAccordionExpandIcon.displayName = 'CustomAccordionExpandIcon';
